import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router';

/**
 * In-app Back / Exit buttons: behave exactly like the browser Back button when there is
 * an in-app page to return to; otherwise (opened from a bookmark or a new tab) go to
 * `fallback` instead of leaving the app.
 */
export function useGoBack(fallback: string) {
  const navigate = useNavigate();
  const loc = useLocation();
  return useCallback(() => {
    if (loc.key !== 'default' && window.history.length > 1) void navigate(-1);
    else void navigate(fallback, { replace: true });
  }, [navigate, loc.key, fallback]);
}
